import {
  GET_ALL_RACKS,
  GET_ALL_RACKS_ERROR,
  GET_ALL_RACKS_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorGetRacks: "",
  loadingGetAllRacks: false,
  racks: null,
  successAllRacks: "",
};

const getAllRacks = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_RACKS:
      state = {
        ...state,
        loadingGetAllRacks: true,
      };
      break;
    case GET_ALL_RACKS_SUCCESS:
      state = {
        ...state,
        loadingGetAllRacks: false,
        racks: action.payload.racks,
        successAllRacks: action.payload.message,
      };

      break;
    case GET_ALL_RACKS_ERROR:
      state = {
        ...state,
        errorGetRacks: action.payload,
        loadingGetAllRacks: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getAllRacks;
